<template>
  <div class="raceDetails pa-3">
    <v-row no-gutters justify="center">
      <v-card id="cardTest" v-for="(item, i) in menu" :key="i" v-model="item.open">
        <v-card-title
          class="my-1 accent"
        >
          <v-icon>{{ item.icon }}</v-icon>
          <span
            depressed
            class="font-weight-bold text-left text-uppercase text-customizer-exp"
            v-html="item.name"
            ></span
          >
        </v-card-title>

        <component v-if="$route.params.id != undefined" :is="item.component"></component>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import Details from "@/components/dashboard/raceDetails/Details.vue";
import Stats from "@/components/dashboard/raceDetails/Stats.vue";
import Banner from "@/components/dashboard/raceDetails/Banner.vue";
import RaceClasses from "@/components/dashboard/raceDetails/RaceClasses.vue";
import RaceScoring from "@/components/dashboard/raceDetails/RaceScoring.vue";
import RaceParticipant from "@/components/dashboard/raceDetails/RaceParticipant.vue";
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  components: {
    Details,
    Stats,
    Banner,
    RaceClasses,
    RaceScoring,
    RaceParticipant,
  },
  data() {
    return {
      editable: "",
    };
  },
  computed: {
    locked() {
      return this.editable.length == 0
            ? "<span style='color: red;'>" +
              this.$t("dashboard.menu.raceDetails.race_locked") +
              "</span>"
            : "";
    },
    menu() {
      var menu_ = [
          {
            name: this.$t("dashboard.menu.raceDetails.raceDetails") + " " + this.locked,
            component: "Details",
            icon: "far fa-info",
          },
          {
            name: this.$t("dashboard.menu.raceDetails.ur_race_stats"),
            component: "Stats",
            icon: "far fa-chart-line",
          },
          {
            name: this.$t("dashboard.menu.raceDetails.race_page_ad"),
            component: "Banner",
            icon: "",
          },
      ];
      return menu_;
    }
  },
  mounted() {
    this.getEvent();
  },
  methods: {
    async getEvent() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/race/getEventByRaceId/" + this.$route.params.id
      );
      if (response.success == 1) {
        this.eventId = response.message;

        var response_ = await this.api(
          "get",
          "/api/v1/promoter/race/getEvent/" + this.eventId
        );
        let eventId = response_.message[0].id;

        var checkForExpiredEvent = await this.api(
          "get",
          "/api/v1/promoter/race/checkForExpiredEvent/" + eventId
        );

        var editable = checkForExpiredEvent.message ? "" : "doedit";
        this.editable = editable;
      }
    },
  },
  created: function () {},
};
</script>

<style>
#cardTest {
  width: 100%;
  border-style: groove;
  border-color: var(--v-error-base);
  margin-bottom: 2%;
}
</style>
